import gql from 'graphql-tag';
import { GraphQLClient } from 'graphql-request';
import { recordGraphQL } from './openReplay';

const endpoint = `${process.env.GATSBY_STOREFRONT_GRAPHQL_URL}`;
if (endpoint.length === 0) throw new Error('GATSBY_STOREFRONT_GRAPHQL_URL is not set');

export const graphqlClient = new GraphQLClient(endpoint, {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

export const setAuthHeader = (token?: string) => {
  // NOTE: Need to set the to set the Auth header if the token is set.
  // Otherwise, we need to clear to to prevent bugs where our user
  // remains logged in unless the user refreshes the page
  graphqlClient.setHeader('Authorization', token ? `Bearer ${token}` : '');
};

export const clearAuthHeader = () => setAuthHeader();

export function graphqlFetcher<TData, TVariables>(query: string, variables?: TVariables) {
  const obj: any = gql`
    ${query}
  `;
  const operation = obj.definitions[0].operation;
  const name = obj.definitions[0].selectionSet.selections[0].name.value;

  const hideVariables = name.includes('login') || name.includes('password');

  return () =>
    graphqlClient.request<TData, TVariables>(query, variables).then(result => {
      recordGraphQL(operation, name, hideVariables ? 'variables hidden for login or password' : variables, result);
      return result;
    });
}
